import React from "react";
import animationData from "./Bell.json";
import Lottie from "react-lottie";

const BellAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div>
      <Lottie options={defaultOptions} height={20} width={20} />
    </div>
  );
};

export default BellAnimation;
